import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import * as Alert from "../../services/sweetalertService"
import * as Constants from "../../common/constants"

import FormTextbox from "../shared/formTextbox"
import FormFieldDisableAutoComplete from "../shared/formFieldDisableAutoComplete"
import FormDropdownArray from "../shared/formDropdownArray"
import { Row, Col } from "react-bootstrap"
import {
  controlEditBenefit,
  updateValidFormData,
  pageIncrement,
  updateClickedNext,
  updateFormIsValid,
} from "../../redux/actions"
import { useDispatch, batch } from "react-redux"
import EditBenefitImg from "../../content/img/editBenefit.png"

const ClaimsPayout = ({ claimData, uiData }) => {
  const {
    pageNumber,
    clickedNext,
    editBenefits,
    bankList,
    hideHeaderFooter,
  } = uiData

  const formName = Constants.payoutFormName
  const dispatch = useDispatch()
  const formRef = React.useRef()

  //   const formClickedNext = clickedNext[formName]

  const accountNumberRegexValidation = inputBIC => {
    if (inputBIC) {
      let indexOfBank = bankList
        .map(function(e) {
          return e.BIC
        })
        .indexOf(inputBIC)
      let matchedBank = bankList[indexOfBank]
      let matchedRegexValidation = matchedBank.RegexValidationJs
      let matchedErrorMessage = matchedBank.ErrorMessage

      return {
        regex: matchedRegexValidation,
        errorMessage: matchedErrorMessage,
      }
    } else {
      return null
    }
  }

  const claimsPayoutSchema = Yup.object().shape({
    accountNumber: Yup.mixed().test({
      name: "validator-custom-accountNumber-regex",
      // eslint-disable-next-line object-shorthand
      test: function(value) {
        if (formRef.current.values.bankBIC && value) {
          // You can add any logic here to generate a dynamic message
          let matchedResult = accountNumberRegexValidation(
            formRef.current.values.bankBIC
          )
          const regex = RegExp(matchedResult.regex)
          return matchedResult
            ? regex.test(value)
              ? true
              : this.createError({
                  message: matchedResult.errorMessage,
                  path: "accountNumber", // Fieldname
                })
            : true
        } else {
          return true
        }
      },
    }),
    // accountName: Yup.string().required(Constants.driverAddressErrorMsg),
  })

  const handleEditBenefit = () => {
    dispatch(controlEditBenefit(formName))
  }

  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimPayoutModel"])}
      enableReinitialize={true}
      validationSchema={claimsPayoutSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, isValid, values }) => (
        <div>
          <Row
            className={
              "col-xs-12 bigScreenNarrowing form-group ReviewChoosedDetailDiv " +
              (pageNumber === 5 && !editBenefits[formName] ? "" : "hide")
            }
          >
            <div className="col-md-10 col-8 summaryBenefit">
              <b> {formName} </b>
            </div>
            <div className="col-md-2 col-4 row noMarginLeftRightSmallScreen">
              <div
                className="col-12 pr-0"
                onClick={() => {
                  handleEditBenefit()
                }}
                onKeyDown={() => {
                  handleEditBenefit()
                }}
                tabIndex="0"
                role="button"
              >
                <img className="editBtn" src={EditBenefitImg} alt=""></img>
              </div>
            </div>
          </Row>
          <FormikForm onSubmit={handleSubmit}>
            <Row
              className={
                pageNumber === 4 || (pageNumber === 5 && editBenefits[formName])
                  ? ""
                  : "hide"
              }
            >
              <div
                className={
                  "title text-center " +
                  (pageNumber === 4 ? "" : "hide") +
                  " " +
                  (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
                }
              >
                Submit online liability claim
              </div>
              <Row
                className={
                  "containerBody " +
                  (pageNumber === 5
                    ? "blueBG summaryContainerBody mb-4 "
                    : "marginTop3x")
                }
              >
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="formContainer"
                >
                  <div
                    className={
                      "horizontal-align marginBottom1x " +
                      (pageNumber === 4 ||
                      (pageNumber === 5 && editBenefits[formName])
                        ? ""
                        : "hide")
                    }
                  >
                    <Col xs={12} md={12}>
                      <div
                        className={
                          "titleText " + (pageNumber === 5 ? "hide" : "")
                        }
                      >
                        Claims Payout Instruction
                      </div>
                    </Col>
                  </div>
                  {
                    <Row
                      className={
                        "form-group " + (editBenefits[formName] ? "" : "hide")
                      }
                    >
                      <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                        <p>{formName}</p>
                      </div>
                      <div className="col-md-3 col-5 marginTop10px">
                        <div
                          className="cursorPointer"
                          role="button"
                          tabIndex="0"
                          onClick={() => dispatch(controlEditBenefit(formName))}
                          onKeyDown={() =>
                            dispatch(controlEditBenefit(formName))
                          }
                        >
                          <p className="doneEdit">DONE EDIT</p>
                        </div>
                      </div>
                    </Row>
                  }
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Name of Bank and Branch"}
                    name="bankName"
                    component={FormDropdownArray}
                    propertyName={"Bank_Name"}
                    dropdownItem={bankList}
                    secondFieldName="bankBIC"
                    secondPropertyName="BIC"
                  />
                  <Field
                    textDesc={"Bank Account Number"}
                    maxLength={30}
                    name="accountNumber"
                    component={FormTextbox}
                  />
                  <Field
                    textDesc={"Name Of Account Holder"}
                    maxLength={100}
                    name="accountName"
                    component={FormTextbox}
                    toUpperCase={false}
                  />
                </Col>
              </Row>
            </Row>
            <HandleFormValidation
              thisPageClickedNext={clickedNext[4]}
              reviewPageClickedNext={clickedNext[5]}
              formRef={formRef}
              values={values}
              thisPageNumber={4}
              dispatch={dispatch}
              formName={formName}
            />
          </FormikForm>
        </div>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  thisPageClickedNext,
  reviewPageClickedNext,
  formRef,
  values,
  thisPageNumber,
  dispatch,
  formName,
}) => {
  React.useEffect(() => {
    if (thisPageClickedNext || reviewPageClickedNext) {
      formRef.current.validateForm().then(errors => {
        // console.log(errors)
        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")
            // console.log(values)

            dispatch(updateValidFormData("claimPayoutModel", values))
            if (thisPageClickedNext) {
              dispatch(pageIncrement())
            } else {
              dispatch(updateFormIsValid(formName, true))
            }
          } else {
            // console.log("FAIl")
            if (thisPageClickedNext) {
              Alert.missingInfoAlert()
            } else {
              dispatch(updateFormIsValid(formName, false))
            }
            formRef.current.submitForm() // Set touched to all fields
          }

          dispatch(updateClickedNext(thisPageNumber, false))
        })
      })
    }
  }, [
    formRef,
    values,
    thisPageNumber,
    dispatch,
    thisPageClickedNext,
    reviewPageClickedNext,
    formName,
  ])
  return null
}

export default ClaimsPayout
